import { render, staticRenderFns } from "./process.vue?vue&type=template&id=5f5e980e&scoped=true&"
import script from "./process.vue?vue&type=script&lang=js&"
export * from "./process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e980e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5e980e')) {
      api.createRecord('5f5e980e', component.options)
    } else {
      api.reload('5f5e980e', component.options)
    }
    module.hot.accept("./process.vue?vue&type=template&id=5f5e980e&scoped=true&", function () {
      api.rerender('5f5e980e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activiti/process.vue"
export default component.exports